import type { AlertRuleListQuery, AuditQuery, BotListQuery } from './dto'

/**
 * Ключи TanStack Query. Один модуль, чтобы WS-редьюсер и хуки не разъезжались:
 * `bot.state` патчит кэш **по этим же** ключам (docs/06 §9).
 */
export const qk = {
  auth: {
    me: ['auth', 'me'] as const
  },
  dashboard: {
    summary: ['dashboard', 'summary'] as const,
    recentEvents: ['dashboard', 'recentEvents'] as const
  },
  bots: {
    /** Корень: `invalidateQueries({ queryKey: qk.bots.root })` при `bot.deleted`. */
    root: ['bots'] as const,
    lists: ['bots', 'list'] as const,
    list: (query: BotListQuery = {}) => ['bots', 'list', query] as const,
    detail: (botId: string) => ['bots', 'detail', botId] as const,
    events: (botId: string) => ['bots', 'events', botId] as const
  },
  mcAccounts: {
    root: ['mcAccounts'] as const,
    list: ['mcAccounts', 'list'] as const,
    authStatus: (accountId: string) => ['mcAccounts', 'authStatus', accountId] as const
  },
  servers: {
    root: ['servers'] as const,
    list: ['servers', 'list'] as const
  },
  org: {
    current: ['org', 'current'] as const
  },
  audit: {
    root: ['audit'] as const,
    /** Фильтры входят в ключ: страницы аудита не сливаются с чужой выборкой. */
    list: (query: AuditQuery = {}) => ['audit', 'list', query] as const
  },
  /** Алерты (docs/06 §7.1). Корень — чтобы инвалидировать любую выборку разом. */
  alerts: {
    root: ['alerts'] as const,
    list: (query: AlertRuleListQuery = {}) => ['alerts', 'list', query] as const
  },
  system: {
    info: ['system', 'info'] as const
  }
} as const
